import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import API from "../../utils/API";
import SectionHeader from "../../components/views/SectionHeader";
import SectionFooter from "../../components/views/SectionFooter";
import TabsContainer from "../../components/views/TabsContainer";
import ToggleField from "../../components/inputs/toggleField";
import InputField from "../../components/inputs/inputField";
import EmailEditor from "../../components/email/emailEditor";
import TemplateCenterModal from "../event/emails/modals/templateCenterModal";
import * as IFrame from "react-iframe-form";
const ENV =
	process.env.NODE_ENV === "production"
		? window.location.href.includes("planner.simple.events")
			? `https://admin-api.simple.events/`
			: `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;

const defaultEmailStructure = {
	confirmation: {
		enabled: false,
	},
	reminder: {
		enabled: false,
		reminderHours: 2,
	},
	cancellation: {
		enabled: false,
	},
};

class BookingEmailTemplates extends Component {
	constructor(props) {
		super(props);

		const currentEmails = props.bookingPage.emails || {};
		const emails = {
			confirmation: {
				...defaultEmailStructure.confirmation,
				...currentEmails.confirmation,
			},
			reminder: {
				...defaultEmailStructure.reminder,
				...currentEmails.reminder,
			},
			cancellation: {
				...defaultEmailStructure.cancellation,
				...currentEmails.cancellation,
			},
		};

		this.state = {
			emails: emails,
			editedEmails: JSON.parse(JSON.stringify(emails)),
			editing: false,
			selectedSection: "setup",
			tabs: [
				{ title: "Setup", id: "setup" },
				{ title: "Confirmation", id: "confirmation" },
				{ title: "Reminder", id: "reminder" },
				{ title: "Cancellation", id: "cancellation" },
			],
			emailBuilderOpen: false,
			templateCenterOpen: false,
			editingEmailType: null,
			platformTemplates: [],
			editCount: 0,
		};
	}

	componentDidMount() {
		const { orgId } = this.props;
		API()
			.get(`/Organizations/${orgId}/getPlatformEmailTemplates`)
			.then((res) => {
				if (res.data) {
					this.setState({
						platformTemplates: res.data.platformTemplates || [],
					});
				}
			});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.bookingPage !== this.props.bookingPage) {
			const currentEmails = this.props.bookingPage.emails || {};
			const emails = {
				confirmation: {
					...defaultEmailStructure.confirmation,
					...currentEmails.confirmation,
				},
				reminder: {
					...defaultEmailStructure.reminder,
					...currentEmails.reminder,
				},
				cancellation: {
					...defaultEmailStructure.cancellation,
					...currentEmails.cancellation,
				},
			};

			this.setState({
				emails: emails,
				editedEmails: JSON.parse(JSON.stringify(emails)),
			});
		}
	}

	updateSelected = (_selectedIndex, selectedId) => {
		this.setState({ selectedSection: selectedId });
	};

	handleToggleEmail = (emailType, enabled) => {
		this.setState({
			editedEmails: {
				...this.state.editedEmails,
				[emailType]: {
					...this.state.editedEmails[emailType],
					enabled,
				},
			},
			editing: true,
		});
	};

	handleEmailChange = (emailType, field, value) => {
		this.setState({
			editedEmails: {
				...this.state.editedEmails,
				[emailType]: {
					...this.state.editedEmails[emailType],
					[field]: value,
				},
			},
			editing: true,
		});
	};

	openEmailBuilder = (emailType) => {
		this.setState({
			editingEmailType: emailType,
			emailBuilderOpen: true,
		});
	};

	openTemplateCenter = (emailType) => {
		this.setState({
			editingEmailType: emailType,
			templateCenterOpen: true,
		});
	};

	handleEmailBuilderUpdate = async (emailTemplate) => {
		const { editingEmailType } = this.state;
		const { orgId } = this.props;
		const bookingPageId = this.props.bookingPage._id;

		try {
			// Save the updated email template
			const payload = {
				request: "updateBookingEmailTemplate",
				emailType: editingEmailType,
				emailTemplate: {
					...this.state.editedEmails[editingEmailType],
					...emailTemplate,
				},
			};

			const response = await API().patch(
				`Organizations/${orgId}/bookingPages/${bookingPageId}`,
				payload
			);

			if (response.data && response.data.email) {
				this.setState({
					editedEmails: {
						...this.state.editedEmails,
						[editingEmailType]: {
							...this.state.editedEmails[editingEmailType],
							template: response.data.email.template,
						},
					},
					editing: false,
					emailBuilderOpen: false,
					editCount: this.state.editCount + 1,
				});
			} else {
				// Fallback to local update
				this.setState({
					editedEmails: {
						...this.state.editedEmails,
						[editingEmailType]: {
							...this.state.editedEmails[editingEmailType],
							template: emailTemplate,
						},
					},
					editing: false,
					emailBuilderOpen: false,
					editCount: this.state.editCount + 1,
				});
			}
		} catch (error) {
			console.error("Error updating email template:", error);
			// Fallback to local update
			this.setState({
				editedEmails: {
					...this.state.editedEmails,
					[editingEmailType]: {
						...this.state.editedEmails[editingEmailType],
						...emailTemplate,
					},
				},
				editing: true,
				emailBuilderOpen: false,
				editCount: this.state.editCount + 1,
			});
		}
	};

	saveEmails = async () => {
		const { orgId } = this.props;
		const { editedEmails } = this.state;
		const bookingPageId = this.props.bookingPage._id;

		try {
			// Now save all email settings
			const payload = {
				request: "updateBookingEmails",
				emails: editedEmails,
			};

			const response = await API().patch(
				`Organizations/${orgId}/bookingPages/${bookingPageId}`,
				payload
			);

			if (response.data && response.data.emails) {
				// Update the parent component's booking page data
				if (this.props.updateBookingPage) {
					this.props.updateBookingPage({
						...this.props.bookingPage,
						emails: response.data.emails,
					});
				}

				this.setState({
					emails: JSON.parse(JSON.stringify(response.data.emails)),
					editedEmails: JSON.parse(JSON.stringify(response.data.emails)),
					editing: false,
				});
			}
		} catch (error) {
			console.error("Error saving email settings:", error);
			// Optionally, show an error message to the user here
		}
	};

	chooseEmailTemplate = async (emailTemplateData, callback) => {
		const { orgId } = this.props;
		const { editedEmails,selectedSection } = this.state;
		const bookingPageId = this.props.bookingPage._id;

		if(selectedSection === "setup"){
			return;
		}

		const updatedEmails = {...editedEmails};
		updatedEmails[selectedSection] = {
			...updatedEmails[selectedSection],
			chosenTemplateDetails: emailTemplateData,
		};

		try {
			// Now save all email settings
			const payload = {
				request: "updateBookingEmails",
				emails: updatedEmails,
			};

			const response = await API().patch(
				`Organizations/${orgId}/bookingPages/${bookingPageId}`,
				payload
			);

			if (response.data && response.data.emails) {
				// Update the parent component's booking page data
				if (this.props.updateBookingPage) {
					this.props.updateBookingPage({
						...this.props.bookingPage,
						emails: response.data.emails,
					});
				}

				this.setState({
					emails: JSON.parse(JSON.stringify(response.data.emails)),
					editedEmails: JSON.parse(JSON.stringify(response.data.emails)),
					editing: false,
				});
				if (callback) {
					callback();
				}
			}
		} catch (error) {
			console.error("Error saving email settings:", error);
			// Optionally, show an error message to the user here
		}
	}

	cancelEdit = () => {
		this.setState({
			editedEmails: JSON.parse(JSON.stringify(this.state.emails)),
			editing: false,
		});
	};

	renderSetupSection = () => {
		const { editedEmails } = this.state;

		return (
			<div className="blocksContainer">
				<div className="flex w-100 gap20">
					<div className="sectionBlock contained-h">
						<h2 className="blockHeader">Email Settings</h2>

						<ToggleField
							label="Confirmation Email"
							information="Sent when customer books a meeting"
							checked={editedEmails.confirmation.enabled}
							onChange={(e) =>
								this.handleToggleEmail("confirmation", e.target.checked)
							}
							icons={false}
						/>

						<ToggleField
							label="Reminder Email"
							information="Sent before the meeting starts"
							checked={editedEmails.reminder.enabled}
							onChange={(e) =>
								this.handleToggleEmail("reminder", e.target.checked)
							}
							icons={false}
						/>

						{editedEmails.reminder.enabled && (
							<InputField
								label="Send reminder"
								type="number"
								value={editedEmails.reminder.reminderHours || 2}
								onChange={(e) =>
									this.handleEmailChange(
										"reminder",
										"reminderHours",
										parseInt(e.target.value)
									)
								}
								placeholder="2"
								information="Hours before the meeting"
							/>
						)}

						<ToggleField
							label="Cancellation Email"
							information="Sent when a meeting is cancelled"
							checked={editedEmails.cancellation.enabled}
							onChange={(e) =>
								this.handleToggleEmail("cancellation", e.target.checked)
							}
							icons={false}
						/>
					</div>
				</div>
			</div>
		);
	};

	handleEmailTemplateChange = (emailType, field, value) => {
		this.setState({
			editedEmails: {
				...this.state.editedEmails,
				[emailType]: {
					...this.state.editedEmails[emailType],
					template: {
						...this.state.editedEmails[emailType].template,
						[field]: value,
					}
				},
			},
			editing: true,
		});
	};

	renderEmailSection = (emailType, title) => {
		const { editedEmails, emails, editCount, emailBuilderOpen, editing } =
			this.state;
		const { orgId } = this.props;
		const editedEmail = editedEmails[emailType];
		const savedEmail = emails[emailType];

		// Check if email is actually enabled and saved (not just toggled in edited state)
		const isEmailSavedAndEnabled = savedEmail.enabled;
		const isEmailToggledOn = editedEmail.enabled;

		if (!isEmailToggledOn) {
			return (
				<div className="blocksContainer">
					<div className="sectionBlock contained-h">
						<div className="explainerBox">
							<div>
								<h3>{title} Disabled</h3>
								<p>Enable in Setup to configure template.</p>
							</div>
						</div>
					</div>
				</div>
			);
		}

		// If email is toggled on but not saved yet, show save required message
		if (isEmailToggledOn && !isEmailSavedAndEnabled) {
			return (
				<div className="blocksContainer">
					<div className="sectionBlock contained-h">
						<div className="explainerBox">
							<div>
								<h3>{title} Enabled</h3>
								<p className="mb-10">
									Save your changes to initialize the email template and access
									the editor.
								</p>
								<button
									className="neu prim"
									onClick={() => this.updateSelected(null, "setup")}
									disabled={!editing}
								>
									Go to Setup
								</button>
							</div>
						</div>
					</div>
				</div>
			);
		}

		if(!savedEmail.template){
			return (
				<div className="blocksContainer">
					<div className="sectionBlock contained-h">
						<div className="explainerBox">
							<div>
								<h3>{title} Not Set Up</h3>
								<p className="mb-10">
									Choose a template to get started with your {title.toLowerCase()}.
								</p>
								<button
									className="neu prim"
									onClick={() => this.openTemplateCenter(emailType)}
									disabled={editing}
								>
									Choose Template
								</button>
							</div>
						</div>
					</div>
				</div>
			);
		}

		// Email is saved and enabled - show full interface
		const email = editedEmail.template; // Use saved email data for display

		return (
			<div className="blocksContainer">
				<div className="flex w-100 gap20">
					<div className="sectionBlock contained-h">
						<h2 className="blockHeader">Email Details</h2>
			
						<InputField
							label="Subject"
							placeholder="Write your subject line"
							value={email.subject}
							onChange={(e) =>
								this.handleEmailTemplateChange(emailType, "subject", e.target.value)
							}
						/>
						<InputField
							label="Preview"
							placeholder="Write a preview message"
							value={email.previewText}
							onChange={(e) =>
								this.handleEmailTemplateChange(emailType, "previewText", e.target.value)
							}
						/>
					</div>

					<div className="sectionBlock emailDesignPreview mt-20">
						<div
							style={{
								maxWidth: "calc(100% - 15px)",
								minWidth: "calc(100% - 700px)",
							}}
							className="cardDetailsContainerPages containerTitle mb-20"
						>
							<div className="w-100">
								<h2 className="blockHeader m-0">Email Preview</h2>
								<p>Preview of how customers will see this email</p>
							</div>
							{email._id ? (
								<div className="flex aic gap10">
									<button
										className={`neu prim ${editing ? "disabled" : ""}`}
										onClick={() => this.openEmailBuilder(emailType)}
										disabled={editing}
									>
										Edit Email
									</button>
								</div>
							) : (
								<button
									className={`neu prim ${editing ? "disabled" : ""}`}
									onClick={() => this.openTemplateCenter(emailType)}
									disabled={editing}
								>
									Choose Template
								</button>
							)}
						</div>

						{email._id ? (
							<div
								style={{
									maxWidth: "calc(100% - 15px)",
									minWidth: "calc(100% - 700px)",
									height: 500,
								}}
							>
								<div className="emailPreview eFrame pages flex-ac preview">
									{!emailBuilderOpen && (
										<IFrame.Form
											id={`builderPreviewFrame${emailType}`}
											className="emailPreviewWindow Frame"
											key={`${emailType}-${editCount}`}
											style={{
												pointerEvents: "none",
												transform: "scale(0.99)",
											}}
											name={`PreviewFrame${emailType}`}
											config={{
												url: `${ENV}Organizations/${orgId}/emailrenderer?preview=true`,
												method: "post",
												data: email,
											}}
										/>
									)}
								</div>
							</div>
						) : (
							<div className="explainerBox">
								<i className="las la-info-circle" style={{ fontSize: 50 }} />
								<div>
									<h2>Set up email template</h2>
									<p>
										Choose a template for your {title.toLowerCase()} or create
										one from scratch to get started.
									</p>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	};

	renderSection = () => {
		const { selectedSection } = this.state;

		switch (selectedSection) {
			case "setup":
				return this.renderSetupSection();
			case "confirmation":
				return this.renderEmailSection("confirmation", "Confirmation Email");
			case "reminder":
				return this.renderEmailSection("reminder", "Reminder Email");
			case "cancellation":
				return this.renderEmailSection("cancellation", "Cancellation Email");
			default:
				return this.renderSetupSection();
		}
	};

	render() {
		const {
			editing,
			selectedSection,
			tabs,
			emailBuilderOpen,
			templateCenterOpen,
			editingEmailType,
		} = this.state;

		const { bookingPage, sectionName, orgId } = this.props;

		return (
			<div className="sectionContainer">
				<SectionHeader
					title={sectionName}
					description="Configure automated booking emails"
					editing={editing}
					breadcrumbs={[{ name: bookingPage.name || "Booking Page" }]}
				>
					<TabsContainer
						tabs={tabs}
						updateSelected={this.updateSelected}
						selectedIndex={tabs.findIndex((tab) => tab.id === selectedSection)}
					/>
				</SectionHeader>

				<div className="sectionBody">{this.renderSection()}</div>

				<SectionFooter
					updatedAt={bookingPage.updatedAt}
					saveEdit={this.saveEmails}
					cancelEdit={this.cancelEdit}
					editing={editing}
				/>

				{emailBuilderOpen && editingEmailType && (
					<EmailEditor
						isOpen={emailBuilderOpen}
						emailTemplate={this.state.emails[editingEmailType].template }
						orgId={orgId}
						eventId={null}
						keyedMetadata={[]}
						keyedData={{}}
						bookingPage={bookingPage}
						branding={bookingPage.styling}
						url={`${ENV}Organizations/${orgId}/emailrenderer`}
						method="post"
						postData={this.state.emails[editingEmailType]}
						toggle={() => this.setState({ emailBuilderOpen: false })}
						update={this.handleEmailBuilderUpdate}
						cancelEdit={() => this.setState({ emailBuilderOpen: false })}
						links={{
							getAssets: `Organizations/${orgId}/assets`,
							addAssets: `Organizations/${orgId}/assets`,
						}}
					/>
				)}

				{templateCenterOpen && (
					<TemplateCenterModal
						isOpen={templateCenterOpen}
						orgId={orgId}
						templates={[]}
						platformTemplates={this.state.platformTemplates}
						eventId={null}
						bookingPage={bookingPage}
						keyedMetadata={[]}
						toggle={() => this.setState({ templateCenterOpen: false })}
						addCampaign={this.selectTemplate}
						defaultSenderEmail="noreply@simple.events"
						defaultSenderName="Booking System"
						isTemplate={true}
						addBookingEmail={this.chooseEmailTemplate}
						bookingId={bookingPage._id}
					/>
				)}
			</div>
		);
	}
}

export default withRouter(BookingEmailTemplates);
